import { POST } from 'utils/requests.utils'

const BASE_URL = '/payer/order_vat_changes'

export const rejectVatChange = (orderId: number) => POST(`${BASE_URL}/${orderId}/reject`)

export const acceptVatChange = (orderId: number) => POST(`${BASE_URL}/${orderId}/accept`)
